import { t } from "ttag";

export const collectionShortcuts = {
  "collection-trash": {
    name: t`Move collection items to trash`,
    shortcut: ["$mod+backspace"],
    shortcutGroup: "collection",
  },
};
